import { Panel } from '../layout/Panel';
import type { ReactNode } from 'react';

export function KpiColumn({ children }: { children: ReactNode }) {
  return <Panel className="panel-kpi">{children}</Panel>;
}
